webpackJsonp([114276838955818,60335399758886],{

/***/ 112:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 215:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(218);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(112);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 326:
/***/ (function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(328);
	var isArguments = __webpack_require__(327);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ }),

/***/ 327:
/***/ (function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ }),

/***/ 328:
/***/ (function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ }),

/***/ 338:
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2015 Jed Watson.
	  Based on code that is Copyright 2013-2015, Facebook, Inc.
	  All rights reserved.
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var canUseDOM = !!(
			typeof window !== 'undefined' &&
			window.document &&
			window.document.createElement
		);
	
		var ExecutionEnvironment = {
	
			canUseDOM: canUseDOM,
	
			canUseWorkers: typeof Worker !== 'undefined',
	
			canUseEventListeners:
				canUseDOM && !!(window.addEventListener || window.attachEvent),
	
			canUseViewport: canUseDOM && !!window.screen
	
		};
	
		if (true) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return ExecutionEnvironment;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else if (typeof module !== 'undefined' && module.exports) {
			module.exports = ExecutionEnvironment;
		} else {
			window.ExecutionEnvironment = ExecutionEnvironment;
		}
	
	}());


/***/ }),

/***/ 520:
/***/ (function(module, exports, __webpack_require__) {

	exports.__esModule = true;
	exports.Helmet = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactSideEffect = __webpack_require__(542);
	
	var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);
	
	var _deepEqual = __webpack_require__(326);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _HelmetUtils = __webpack_require__(521);
	
	var _HelmetConstants = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Helmet = function Helmet(Component) {
	    var _class, _temp;
	
	    return _temp = _class = function (_React$Component) {
	        _inherits(HelmetWrapper, _React$Component);
	
	        function HelmetWrapper() {
	            _classCallCheck(this, HelmetWrapper);
	
	            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	        }
	
	        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	            return !(0, _deepEqual2.default)(this.props, nextProps);
	        };
	
	        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
	            if (!nestedChildren) {
	                return null;
	            }
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.SCRIPT:
	                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    return {
	                        innerHTML: nestedChildren
	                    };
	
	                case _HelmetConstants.TAG_NAMES.STYLE:
	                    return {
	                        cssText: nestedChildren
	                    };
	            }
	
	            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
	        };
	
	        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
	            var _extends2;
	
	            var child = _ref.child,
	                arrayTypeChildren = _ref.arrayTypeChildren,
	                newChildProps = _ref.newChildProps,
	                nestedChildren = _ref.nestedChildren;
	
	            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
	        };
	
	        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
	            var _extends3, _extends4;
	
	            var child = _ref2.child,
	                newProps = _ref2.newProps,
	                newChildProps = _ref2.newChildProps,
	                nestedChildren = _ref2.nestedChildren;
	
	            switch (child.type) {
	                case _HelmetConstants.TAG_NAMES.TITLE:
	                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));
	
	                case _HelmetConstants.TAG_NAMES.BODY:
	                    return _extends({}, newProps, {
	                        bodyAttributes: _extends({}, newChildProps)
	                    });
	
	                case _HelmetConstants.TAG_NAMES.HTML:
	                    return _extends({}, newProps, {
	                        htmlAttributes: _extends({}, newChildProps)
	                    });
	            }
	
	            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
	        };
	
	        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
	            var newFlattenedProps = _extends({}, newProps);
	
	            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
	                var _extends5;
	
	                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
	            });
	
	            return newFlattenedProps;
	        };
	
	        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
	            if (false) {
	                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
	                    return child.type === name;
	                })) {
	                    if (typeof child.type === "function") {
	                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
	                    }
	
	                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
	                }
	
	                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
	                    return typeof nestedChild !== "string";
	                }))) {
	                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
	                }
	            }
	
	            return true;
	        };
	
	        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
	            var _this2 = this;
	
	            var arrayTypeChildren = {};
	
	            _react2.default.Children.forEach(children, function (child) {
	                if (!child || !child.props) {
	                    return;
	                }
	
	                var _child$props = child.props,
	                    nestedChildren = _child$props.children,
	                    childProps = _objectWithoutProperties(_child$props, ["children"]);
	
	                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);
	
	                _this2.warnOnInvalidChildren(child, nestedChildren);
	
	                switch (child.type) {
	                    case _HelmetConstants.TAG_NAMES.LINK:
	                    case _HelmetConstants.TAG_NAMES.META:
	                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
	                    case _HelmetConstants.TAG_NAMES.SCRIPT:
	                    case _HelmetConstants.TAG_NAMES.STYLE:
	                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
	                            child: child,
	                            arrayTypeChildren: arrayTypeChildren,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	
	                    default:
	                        newProps = _this2.mapObjectTypeChildren({
	                            child: child,
	                            newProps: newProps,
	                            newChildProps: newChildProps,
	                            nestedChildren: nestedChildren
	                        });
	                        break;
	                }
	            });
	
	            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
	            return newProps;
	        };
	
	        HelmetWrapper.prototype.render = function render() {
	            var _props = this.props,
	                children = _props.children,
	                props = _objectWithoutProperties(_props, ["children"]);
	
	            var newProps = _extends({}, props);
	
	            if (children) {
	                newProps = this.mapChildrenToProps(children, newProps);
	            }
	
	            return _react2.default.createElement(Component, newProps);
	        };
	
	        _createClass(HelmetWrapper, null, [{
	            key: "canUseDOM",
	
	
	            // Component.peek comes from react-side-effect:
	            // For testing, you may use a static peek() method available on the returned component.
	            // It lets you get the current state without resetting the mounted instance stack.
	            // Don’t use it for anything other than testing.
	
	            /**
	            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
	            * @param {Object} bodyAttributes: {"className": "root"}
	            * @param {String} defaultTitle: "Default Title"
	            * @param {Boolean} defer: true
	            * @param {Boolean} encodeSpecialCharacters: true
	            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
	            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
	            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
	            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
	            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
	            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
	            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
	            * @param {String} title: "Title"
	            * @param {Object} titleAttributes: {"itemprop": "name"}
	            * @param {String} titleTemplate: "MySite.com - %s"
	            */
	            set: function set(canUseDOM) {
	                Component.canUseDOM = canUseDOM;
	            }
	        }]);
	
	        return HelmetWrapper;
	    }(_react2.default.Component), _class.propTypes = {
	        base: _propTypes2.default.object,
	        bodyAttributes: _propTypes2.default.object,
	        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
	        defaultTitle: _propTypes2.default.string,
	        defer: _propTypes2.default.bool,
	        encodeSpecialCharacters: _propTypes2.default.bool,
	        htmlAttributes: _propTypes2.default.object,
	        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        onChangeClientState: _propTypes2.default.func,
	        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
	        title: _propTypes2.default.string,
	        titleAttributes: _propTypes2.default.object,
	        titleTemplate: _propTypes2.default.string
	    }, _class.defaultProps = {
	        defer: true,
	        encodeSpecialCharacters: true
	    }, _class.peek = Component.peek, _class.rewind = function () {
	        var mappedState = Component.rewind();
	        if (!mappedState) {
	            // provide fallback if mappedState is undefined
	            mappedState = (0, _HelmetUtils.mapStateOnServer)({
	                baseTag: [],
	                bodyAttributes: {},
	                encodeSpecialCharacters: true,
	                htmlAttributes: {},
	                linkTags: [],
	                metaTags: [],
	                noscriptTags: [],
	                scriptTags: [],
	                styleTags: [],
	                title: "",
	                titleAttributes: {}
	            });
	        }
	
	        return mappedState;
	    }, _temp;
	};
	
	var NullComponent = function NullComponent() {
	    return null;
	};
	
	var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);
	
	var HelmetExport = Helmet(HelmetSideEffects);
	HelmetExport.renderStatic = HelmetExport.rewind;
	
	exports.Helmet = HelmetExport;
	exports.default = HelmetExport;

/***/ }),

/***/ 199:
/***/ (function(module, exports) {

	exports.__esModule = true;
	var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
	    BODY: "bodyAttributes",
	    HTML: "htmlAttributes",
	    TITLE: "titleAttributes"
	};
	
	var TAG_NAMES = exports.TAG_NAMES = {
	    BASE: "base",
	    BODY: "body",
	    HEAD: "head",
	    HTML: "html",
	    LINK: "link",
	    META: "meta",
	    NOSCRIPT: "noscript",
	    SCRIPT: "script",
	    STYLE: "style",
	    TITLE: "title"
	};
	
	var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
	    return TAG_NAMES[name];
	});
	
	var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
	    CHARSET: "charset",
	    CSS_TEXT: "cssText",
	    HREF: "href",
	    HTTPEQUIV: "http-equiv",
	    INNER_HTML: "innerHTML",
	    ITEM_PROP: "itemprop",
	    NAME: "name",
	    PROPERTY: "property",
	    REL: "rel",
	    SRC: "src"
	};
	
	var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
	    accesskey: "accessKey",
	    charset: "charSet",
	    class: "className",
	    contenteditable: "contentEditable",
	    contextmenu: "contextMenu",
	    "http-equiv": "httpEquiv",
	    itemprop: "itemProp",
	    tabindex: "tabIndex"
	};
	
	var HELMET_PROPS = exports.HELMET_PROPS = {
	    DEFAULT_TITLE: "defaultTitle",
	    DEFER: "defer",
	    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
	    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
	    TITLE_TEMPLATE: "titleTemplate"
	};
	
	var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
	    obj[REACT_TAG_MAP[key]] = key;
	    return obj;
	}, {});
	
	var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];
	
	var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),

/***/ 521:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
	exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _objectAssign = __webpack_require__(7);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var _HelmetConstants = __webpack_require__(199);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
	    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	    if (encode === false) {
	        return String(str);
	    }
	
	    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
	};
	
	var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
	    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
	    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);
	
	    if (innermostTemplate && innermostTitle) {
	        // use function arg to avoid need to escape $ characters
	        return innermostTemplate.replace(/%s/g, function () {
	            return innermostTitle;
	        });
	    }
	
	    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);
	
	    return innermostTitle || innermostDefaultTitle || undefined;
	};
	
	var getOnChangeClientState = function getOnChangeClientState(propsList) {
	    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
	};
	
	var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[tagType] !== "undefined";
	    }).map(function (props) {
	        return props[tagType];
	    }).reduce(function (tagAttrs, current) {
	        return _extends({}, tagAttrs, current);
	    }, {});
	};
	
	var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
	    return propsList.filter(function (props) {
	        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
	    }).map(function (props) {
	        return props[_HelmetConstants.TAG_NAMES.BASE];
	    }).reverse().reduce(function (innermostBaseTag, tag) {
	        if (!innermostBaseTag.length) {
	            var keys = Object.keys(tag);
	
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
	                    return innermostBaseTag.concat(tag);
	                }
	            }
	        }
	
	        return innermostBaseTag;
	    }, []);
	};
	
	var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
	    // Calculate list of tags, giving priority innermost component (end of the propslist)
	    var approvedSeenTags = {};
	
	    return propsList.filter(function (props) {
	        if (Array.isArray(props[tagName])) {
	            return true;
	        }
	        if (typeof props[tagName] !== "undefined") {
	            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
	        }
	        return false;
	    }).map(function (props) {
	        return props[tagName];
	    }).reverse().reduce(function (approvedTags, instanceTags) {
	        var instanceSeenTags = {};
	
	        instanceTags.filter(function (tag) {
	            var primaryAttributeKey = void 0;
	            var keys = Object.keys(tag);
	            for (var i = 0; i < keys.length; i++) {
	                var attributeKey = keys[i];
	                var lowerCaseAttributeKey = attributeKey.toLowerCase();
	
	                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
	                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
	                    primaryAttributeKey = lowerCaseAttributeKey;
	                }
	                // Special case for innerHTML which doesn't work lowercased
	                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
	                    primaryAttributeKey = attributeKey;
	                }
	            }
	
	            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
	                return false;
	            }
	
	            var value = tag[primaryAttributeKey].toLowerCase();
	
	            if (!approvedSeenTags[primaryAttributeKey]) {
	                approvedSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!instanceSeenTags[primaryAttributeKey]) {
	                instanceSeenTags[primaryAttributeKey] = {};
	            }
	
	            if (!approvedSeenTags[primaryAttributeKey][value]) {
	                instanceSeenTags[primaryAttributeKey][value] = true;
	                return true;
	            }
	
	            return false;
	        }).reverse().forEach(function (tag) {
	            return approvedTags.push(tag);
	        });
	
	        // Update seen tags with tags from this instance
	        var keys = Object.keys(instanceSeenTags);
	        for (var i = 0; i < keys.length; i++) {
	            var attributeKey = keys[i];
	            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);
	
	            approvedSeenTags[attributeKey] = tagUnion;
	        }
	
	        return approvedTags;
	    }, []).reverse();
	};
	
	var getInnermostProperty = function getInnermostProperty(propsList, property) {
	    for (var i = propsList.length - 1; i >= 0; i--) {
	        var props = propsList[i];
	
	        if (props.hasOwnProperty(property)) {
	            return props[property];
	        }
	    }
	
	    return null;
	};
	
	var reducePropsToState = function reducePropsToState(propsList) {
	    return {
	        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
	        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
	        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
	        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
	        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
	        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
	        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        onChangeClientState: getOnChangeClientState(propsList),
	        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
	        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
	        title: getTitleFromPropsList(propsList),
	        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
	    };
	};
	
	var rafPolyfill = function () {
	    var clock = Date.now();
	
	    return function (callback) {
	        var currentTime = Date.now();
	
	        if (currentTime - clock > 16) {
	            clock = currentTime;
	            callback(currentTime);
	        } else {
	            setTimeout(function () {
	                rafPolyfill(callback);
	            }, 0);
	        }
	    };
	}();
	
	var cafPolyfill = function cafPolyfill(id) {
	    return clearTimeout(id);
	};
	
	var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;
	
	var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;
	
	var warn = function warn(msg) {
	    return console && typeof console.warn === "function" && console.warn(msg);
	};
	
	var _helmetCallback = null;
	
	var handleClientStateChange = function handleClientStateChange(newState) {
	    if (_helmetCallback) {
	        cancelAnimationFrame(_helmetCallback);
	    }
	
	    if (newState.defer) {
	        _helmetCallback = requestAnimationFrame(function () {
	            commitTagChanges(newState, function () {
	                _helmetCallback = null;
	            });
	        });
	    } else {
	        commitTagChanges(newState);
	        _helmetCallback = null;
	    }
	};
	
	var commitTagChanges = function commitTagChanges(newState, cb) {
	    var baseTag = newState.baseTag,
	        bodyAttributes = newState.bodyAttributes,
	        htmlAttributes = newState.htmlAttributes,
	        linkTags = newState.linkTags,
	        metaTags = newState.metaTags,
	        noscriptTags = newState.noscriptTags,
	        onChangeClientState = newState.onChangeClientState,
	        scriptTags = newState.scriptTags,
	        styleTags = newState.styleTags,
	        title = newState.title,
	        titleAttributes = newState.titleAttributes;
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
	    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);
	
	    updateTitle(title, titleAttributes);
	
	    var tagUpdates = {
	        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
	        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
	        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
	        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
	        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
	        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
	    };
	
	    var addedTags = {};
	    var removedTags = {};
	
	    Object.keys(tagUpdates).forEach(function (tagType) {
	        var _tagUpdates$tagType = tagUpdates[tagType],
	            newTags = _tagUpdates$tagType.newTags,
	            oldTags = _tagUpdates$tagType.oldTags;
	
	
	        if (newTags.length) {
	            addedTags[tagType] = newTags;
	        }
	        if (oldTags.length) {
	            removedTags[tagType] = tagUpdates[tagType].oldTags;
	        }
	    });
	
	    cb && cb();
	
	    onChangeClientState(newState, addedTags, removedTags);
	};
	
	var flattenArray = function flattenArray(possibleArray) {
	    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
	};
	
	var updateTitle = function updateTitle(title, attributes) {
	    if (typeof title !== "undefined" && document.title !== title) {
	        document.title = flattenArray(title);
	    }
	
	    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
	};
	
	var updateAttributes = function updateAttributes(tagName, attributes) {
	    var elementTag = document.getElementsByTagName(tagName)[0];
	
	    if (!elementTag) {
	        return;
	    }
	
	    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
	    var attributesToRemove = [].concat(helmetAttributes);
	    var attributeKeys = Object.keys(attributes);
	
	    for (var i = 0; i < attributeKeys.length; i++) {
	        var attribute = attributeKeys[i];
	        var value = attributes[attribute] || "";
	
	        if (elementTag.getAttribute(attribute) !== value) {
	            elementTag.setAttribute(attribute, value);
	        }
	
	        if (helmetAttributes.indexOf(attribute) === -1) {
	            helmetAttributes.push(attribute);
	        }
	
	        var indexToSave = attributesToRemove.indexOf(attribute);
	        if (indexToSave !== -1) {
	            attributesToRemove.splice(indexToSave, 1);
	        }
	    }
	
	    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
	        elementTag.removeAttribute(attributesToRemove[_i]);
	    }
	
	    if (helmetAttributes.length === attributesToRemove.length) {
	        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
	    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
	        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
	    }
	};
	
	var updateTags = function updateTags(type, tags) {
	    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
	    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
	    var oldTags = Array.prototype.slice.call(tagNodes);
	    var newTags = [];
	    var indexToDelete = void 0;
	
	    if (tags && tags.length) {
	        tags.forEach(function (tag) {
	            var newElement = document.createElement(type);
	
	            for (var attribute in tag) {
	                if (tag.hasOwnProperty(attribute)) {
	                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
	                        newElement.innerHTML = tag.innerHTML;
	                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                        if (newElement.styleSheet) {
	                            newElement.styleSheet.cssText = tag.cssText;
	                        } else {
	                            newElement.appendChild(document.createTextNode(tag.cssText));
	                        }
	                    } else {
	                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
	                        newElement.setAttribute(attribute, value);
	                    }
	                }
	            }
	
	            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");
	
	            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
	            if (oldTags.some(function (existingTag, index) {
	                indexToDelete = index;
	                return newElement.isEqualNode(existingTag);
	            })) {
	                oldTags.splice(indexToDelete, 1);
	            } else {
	                newTags.push(newElement);
	            }
	        });
	    }
	
	    oldTags.forEach(function (tag) {
	        return tag.parentNode.removeChild(tag);
	    });
	    newTags.forEach(function (tag) {
	        return headElement.appendChild(tag);
	    });
	
	    return {
	        oldTags: oldTags,
	        newTags: newTags
	    };
	};
	
	var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
	    return Object.keys(attributes).reduce(function (str, key) {
	        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
	        return str ? str + " " + attr : attr;
	    }, "");
	};
	
	var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
	    var attributeString = generateElementAttributesAsString(attributes);
	    var flattenedTitle = flattenArray(title);
	    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
	};
	
	var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
	    return tags.reduce(function (str, tag) {
	        var attributeHtml = Object.keys(tag).filter(function (attribute) {
	            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
	        }).reduce(function (string, attribute) {
	            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
	            return string ? string + " " + attr : attr;
	        }, "");
	
	        var tagContent = tag.innerHTML || tag.cssText || "";
	
	        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;
	
	        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
	    }, "");
	};
	
	var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
	    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(attributes).reduce(function (obj, key) {
	        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
	        return obj;
	    }, initProps);
	};
	
	var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
	    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    return Object.keys(props).reduce(function (obj, key) {
	        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
	        return obj;
	    }, initAttributes);
	};
	
	var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
	    var _initProps;
	
	    // assigning into an array to define toString function on it
	    var initProps = (_initProps = {
	        key: title
	    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
	    var props = convertElementAttributestoReactProps(attributes, initProps);
	
	    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
	};
	
	var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
	    return tags.map(function (tag, i) {
	        var _mappedTag;
	
	        var mappedTag = (_mappedTag = {
	            key: i
	        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);
	
	        Object.keys(tag).forEach(function (attribute) {
	            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;
	
	            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
	                var content = tag.innerHTML || tag.cssText;
	                mappedTag.dangerouslySetInnerHTML = { __html: content };
	            } else {
	                mappedTag[mappedAttribute] = tag[attribute];
	            }
	        });
	
	        return _react2.default.createElement(type, mappedTag);
	    });
	};
	
	var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
	    switch (type) {
	        case _HelmetConstants.TAG_NAMES.TITLE:
	            return {
	                toComponent: function toComponent() {
	                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
	                },
	                toString: function toString() {
	                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
	                }
	            };
	        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
	        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
	            return {
	                toComponent: function toComponent() {
	                    return convertElementAttributestoReactProps(tags);
	                },
	                toString: function toString() {
	                    return generateElementAttributesAsString(tags);
	                }
	            };
	        default:
	            return {
	                toComponent: function toComponent() {
	                    return generateTagsAsReactComponent(type, tags);
	                },
	                toString: function toString() {
	                    return generateTagsAsString(type, tags, encode);
	                }
	            };
	    }
	};
	
	var mapStateOnServer = function mapStateOnServer(_ref) {
	    var baseTag = _ref.baseTag,
	        bodyAttributes = _ref.bodyAttributes,
	        encode = _ref.encode,
	        htmlAttributes = _ref.htmlAttributes,
	        linkTags = _ref.linkTags,
	        metaTags = _ref.metaTags,
	        noscriptTags = _ref.noscriptTags,
	        scriptTags = _ref.scriptTags,
	        styleTags = _ref.styleTags,
	        _ref$title = _ref.title,
	        title = _ref$title === undefined ? "" : _ref$title,
	        titleAttributes = _ref.titleAttributes;
	    return {
	        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
	        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
	        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
	        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
	        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
	        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
	        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
	        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
	        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
	    };
	};
	
	exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
	exports.handleClientStateChange = handleClientStateChange;
	exports.mapStateOnServer = mapStateOnServer;
	exports.reducePropsToState = reducePropsToState;
	exports.requestAnimationFrame = requestAnimationFrame;
	exports.warn = warn;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _exenv = __webpack_require__(338);
	
	var _exenv2 = _interopRequireDefault(_exenv);
	
	var _shallowequal = __webpack_require__(563);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	module.exports = function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
	  if (typeof reducePropsToState !== 'function') {
	    throw new Error('Expected reducePropsToState to be a function.');
	  }
	  if (typeof handleStateChangeOnClient !== 'function') {
	    throw new Error('Expected handleStateChangeOnClient to be a function.');
	  }
	  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
	    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
	  }
	
	  function getDisplayName(WrappedComponent) {
	    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	  }
	
	  return function wrap(WrappedComponent) {
	    if (typeof WrappedComponent !== 'function') {
	      throw new Error('Expected WrappedComponent to be a React component.');
	    }
	
	    var mountedInstances = [];
	    var state = void 0;
	
	    function emitChange() {
	      state = reducePropsToState(mountedInstances.map(function (instance) {
	        return instance.props;
	      }));
	
	      if (SideEffect.canUseDOM) {
	        handleStateChangeOnClient(state);
	      } else if (mapStateOnServer) {
	        state = mapStateOnServer(state);
	      }
	    }
	
	    var SideEffect = function (_Component) {
	      _inherits(SideEffect, _Component);
	
	      function SideEffect() {
	        _classCallCheck(this, SideEffect);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      // Try to use displayName of wrapped component
	      SideEffect.peek = function peek() {
	        return state;
	      };
	
	      // Expose canUseDOM so tests can monkeypatch it
	
	
	      SideEffect.rewind = function rewind() {
	        if (SideEffect.canUseDOM) {
	          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
	        }
	
	        var recordedState = state;
	        state = undefined;
	        mountedInstances = [];
	        return recordedState;
	      };
	
	      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return !(0, _shallowequal2.default)(nextProps, this.props);
	      };
	
	      SideEffect.prototype.componentWillMount = function componentWillMount() {
	        mountedInstances.push(this);
	        emitChange();
	      };
	
	      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
	        emitChange();
	      };
	
	      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
	        var index = mountedInstances.indexOf(this);
	        mountedInstances.splice(index, 1);
	        emitChange();
	      };
	
	      SideEffect.prototype.render = function render() {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      };
	
	      return SideEffect;
	    }(_react.Component);
	
	    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
	    SideEffect.canUseDOM = _exenv2.default.canUseDOM;
	
	
	    return SideEffect;
	  };
	};

/***/ }),

/***/ 563:
/***/ (function(module, exports) {

	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	
	    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	    if(ret !== void 0) {
	        return !!ret;
	    }
	
	    if(objA === objB) {
	        return true;
	    }
	
	    if(typeof objA !== 'object' || !objA ||
	       typeof objB !== 'object' || !objB) {
	        return false;
	    }
	
	    var keysA = Object.keys(objA);
	    var keysB = Object.keys(objB);
	
	    if(keysA.length !== keysB.length) {
	        return false;
	    }
	
	    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	    // Test for A's keys different from B.
	    for(var idx = 0; idx < keysA.length; idx++) {
	
	        var key = keysA[idx];
	
	        if(!bHasOwnProperty(key)) {
	            return false;
	        }
	
	        var valueA = objA[key];
	        var valueB = objB[key];
	
	        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	        if(ret === false ||
	           ret === void 0 && valueA !== valueB) {
	            return false;
	        }
	
	    }
	
	    return true;
	
	};


/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo_square = __webpack_require__(59);
	
	var _logo_square2 = _interopRequireDefault(_logo_square);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'navbar navbar-default navbar-static-top' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container-fluid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-header' },
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'navbar-toggle collapsed hidden-xs',
	            'data-toggle': 'collapse',
	            'data-target': '#navbar',
	            'aria-expanded': 'false',
	            'aria-controls': 'navbar'
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            'Toggle navigation'
	          ),
	          _react2.default.createElement('span', { className: 'icon-bar' }),
	          _react2.default.createElement('span', { className: 'icon-bar' }),
	          _react2.default.createElement('span', { className: 'icon-bar' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'navbar-brand', href: '/' },
	          _react2.default.createElement('img', { src: _logo_square2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'navbar', className: 'collapse navbar-collapse pull-right' },
	        _react2.default.createElement(
	          'ul',
	          { className: 'nav navbar-nav' },
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/' },
	              'Home'
	            )
	          ),
	          _react2.default.createElement(
	            'li',
	            null,
	            _react2.default.createElement(
	              'a',
	              { href: '/#contact' },
	              'Contact'
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 81:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(24);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _logo = __webpack_require__(58);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	var _logoV = __webpack_require__(140);
	
	var _logoV2 = _interopRequireDefault(_logoV);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Header = function Header() {
	  return _react2.default.createElement(
	    'nav',
	    { className: 'navbar navbar-default navbar-static-top' },
	    _react2.default.createElement(
	      'div',
	      { className: 'container-fluid' },
	      _react2.default.createElement(
	        'div',
	        { className: 'navbar-header' },
	        _react2.default.createElement(
	          'button',
	          {
	            type: 'button',
	            className: 'navbar-toggle collapsed hidden-xs',
	            'data-toggle': 'collapse',
	            'data-target': '#navbar',
	            'aria-expanded': 'false',
	            'aria-controls': 'navbar'
	          },
	          _react2.default.createElement(
	            'span',
	            { className: 'sr-only' },
	            'Toggle navigation'
	          ),
	          _react2.default.createElement('span', { className: 'icon-bar' }),
	          _react2.default.createElement('span', { className: 'icon-bar' }),
	          _react2.default.createElement('span', { className: 'icon-bar' })
	        ),
	        _react2.default.createElement(
	          'a',
	          { className: 'navbar-brand', href: '/' },
	          _react2.default.createElement('img', { className: 'logo hidden-xs hidden-sm', src: _logo2.default }),
	          _react2.default.createElement('img', { className: 'logo visible-xs visible-sm', src: _logoV2.default })
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { id: 'navbar', className: 'collapse navbar-collapse pull-right' },
	        _react2.default.createElement('ul', { className: 'nav navbar-nav' })
	      )
	    )
	  );
	};
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 580:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 140:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 59:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAdCAYAAAC9pNwMAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMC1jMDYwIDYxLjEzNDc3NywgMjAxMC8wMi8xMi0xNzozMjowMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNSBNYWNpbnRvc2giIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6RjYzMzY0REY2MkZFMTFFQTkzNEJGMDVGNzcwNEYxM0MiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RjYzMzY0RTA2MkZFMTFFQTkzNEJGMDVGNzcwNEYxM0MiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDpGNjMzNjRERDYyRkUxMUVBOTM0QkYwNUY3NzA0RjEzQyIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDpGNjMzNjRERTYyRkUxMUVBOTM0QkYwNUY3NzA0RjEzQyIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PoOR7wYAAAF3SURBVHja3FfBUcMwEJSZ8CYdoA5iKsBUEPgzg+nAJcQVQAcoMxSQDmIqwHTgdEDefLLH3EM+ZHEYOwncjMYjS9ZKp92VnJxe3j4YY1KjiI+X56tYO8ZaG124CYNmZpjQjlOdmAPFRM6ES99YRNpyFNsJjH0s+6LGvsX+Zz7wwVJ9NHusCqRthseUqzVSvB0NGGBneBSSJNzWELEwgeWgqWbQillrA13onUO/p5+suPbqTUQmqejnAjLJAV51rLyFkyhWey4mtMLANyIbtQe+0EhSk+prUS+EdrecESpTrQ9oyNVKMQbeBIxjOYaOrYIDf8dANMDvHasfHdg/rSyzXDL/jjSMMtcCJ8L+vpCnh5zIQi++sdmGWP3o3RxIEqVg7AYfOTaKT3mh/koTCJ2zPF4oWjhary5YVqknsdA9zWmlpWI1m0TGGWk67DBHv/vBTycGp20o93osikm8/WsD2cvVJ+fb4Bh/EmkM2P7SFrOjT/VOgAEAzF6I2cldyO0AAAAASUVORK5CYII="

/***/ }),

/***/ 340:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 218:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(520);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(81);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _BlogHeader = __webpack_require__(43);
	
	var _BlogHeader2 = _interopRequireDefault(_BlogHeader);
	
	var _favicon = __webpack_require__(580);
	
	var _favicon2 = _interopRequireDefault(_favicon);
	
	__webpack_require__(339);
	
	__webpack_require__(340);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TemplateWrapper = function TemplateWrapper(_ref) {
	  var children = _ref.children,
	      location = _ref.location;
	
	  if (location.pathname.startsWith('/blog') || location.pathname.startsWith('/abc')) {
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_reactHelmet2.default, {
	        title: 'Cornerstone Church Portsmouth',
	        meta: [{
	          name: 'description',
	          content: 'We are a church that wants to help people come to know Jesus more.'
	        }, {
	          name: 'keywords',
	          content: 'jesus, church, portsmouth, cornerstone, bible, life'
	        }],
	        link: [{
	          rel: 'icon',
	          type: 'image/png',
	          sizes: '16x16',
	          href: '' + _favicon2.default
	        }]
	      }),
	      _react2.default.createElement(_BlogHeader2.default, null),
	      children()
	    );
	  }
	  return location.pathname !== '/christmascraft/' ? _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Cornerstone Church Portsmouth',
	      meta: [{
	        name: 'description',
	        content: 'We are a church that wants to help people come to know Jesus more.'
	      }, {
	        name: 'keywords',
	        content: 'jesus, church, portsmouth, cornerstone, bible, life'
	      }],
	      link: [{
	        rel: 'icon',
	        type: 'image/png',
	        sizes: '16x16',
	        href: '' + _favicon2.default
	      }]
	    }),
	    children(),
	    _react2.default.createElement(
	      'section',
	      null,
	      _react2.default.createElement(
	        'div',
	        { className: 'container', style: { paddingTop: 0 } },
	        _react2.default.createElement(
	          'div',
	          { className: 'row' },
	          _react2.default.createElement(
	            'p',
	            { style: { fontSize: '16px', textAlign: 'center' } },
	            'Cornerstone Church Portsmouth CIO is a registered charity, no.1178431'
	          )
	        )
	      )
	    )
	  ) : children();
	};
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-10df8a78b1f19eef0057.js